if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) {
          return;
        }

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton?.querySelector('span');

        if (
          this.cart &&
          this.submitButton &&
          document.querySelector('cart-drawer')
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }


      /* ======================================================
         ADD TO CART
         ====================================================== */

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }


        /* ----------------------------------------------------
           Normal Dawn request configuration
           ---------------------------------------------------- */

        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        const formData =
          new FormData(this.form);

        const variantId =
          formData.get('id');

        const quantity =
          parseInt(
            formData.get('quantity'),
            10
          ) || 1;


        /* ====================================================
           EXISTING "YOU MAY ALSO NEED..." ADD-ONS
           ==================================================== */

        const selectedProductAddons =
          Array.from(
            this.querySelectorAll(
              '[data-product-addon]'
            )
          ).filter((addon) => {
            const checkbox =
              addon.querySelector(
                '[data-addon-checkbox]'
              );

            return (
              checkbox &&
              checkbox.checked &&
              !checkbox.disabled
            );
          });


        /* ====================================================
           147 ADD-ON CHOICE GROUPS
           Extension / Cue Case / future choice groups
           ==================================================== */

        const productRoot =
          this.closest('product-info');

        const selectedChoiceAddons =
          productRoot
            ? Array.from(
                productRoot.querySelectorAll(
                  '[data-a147-addon-radio]:checked'
                )
              ).filter((radio) => {
                /*
                  "Without..." radios deliberately have no
                  variant ID and therefore are ignored.
                */

                const addonVariantId =
                  Number(
                    radio.dataset.variantId ||
                    radio.value
                  );

                return (
                  !radio.disabled &&
                  Number.isFinite(
                    addonVariantId
                  ) &&
                  addonVariantId > 0
                );
              })
            : [];


        const hasSelectedProductAddons =
          selectedProductAddons.length > 0;

        const hasSelectedChoiceAddons =
          selectedChoiceAddons.length > 0;

        const hasAnySelectedAddons =
          hasSelectedProductAddons ||
          hasSelectedChoiceAddons;


        /* ====================================================
           MULTI-ITEM CART REQUEST
           ==================================================== */

        if (hasAnySelectedAddons) {

          config.headers[
            'Content-Type'
          ] = 'application/json';


          /*
            One private group ID associates the main product
            and every selected 147 add-on in this transaction.
          */

          const addonGroupId =
            typeof crypto !== 'undefined' &&
            crypto.randomUUID
              ? crypto.randomUUID()
              : `${Date.now()}-${Math.random()
                  .toString(36)
                  .slice(2)}`;


          /* --------------------------------------------------
             Preserve normal Shopify line-item properties
             belonging to the main product.
             -------------------------------------------------- */

          const mainProperties = {};

          for (
            const [key, value]
            of formData.entries()
          ) {
            const propertyMatch =
              key.match(
                /^properties\[(.+)\]$/
              );

            if (
              propertyMatch &&
              value !== ''
            ) {
              mainProperties[
                propertyMatch[1]
              ] = value;
            }
          }


          /*
            Private property connecting the main product to
            its selected add-ons.
          */

          mainProperties[
            '_147_addon_group'
          ] = addonGroupId;


          /* --------------------------------------------------
             Main product
             -------------------------------------------------- */

          const items = [
            {
              id: Number(
                variantId
              ),

              quantity:
                quantity,

              properties:
                mainProperties,
            },
          ];


          /* --------------------------------------------------
             Preserve selling plan on the main product
             -------------------------------------------------- */

          const sellingPlan =
            formData.get(
              'selling_plan'
            );

          if (sellingPlan) {
            items[0].selling_plan =
              Number(
                sellingPlan
              );
          }


          /* ==================================================
             EXISTING "YOU MAY ALSO NEED..." ITEMS
             ================================================== */

          selectedProductAddons.forEach(
            (addon) => {

              const checkbox =
                addon.querySelector(
                  '[data-addon-checkbox]'
                );

              if (!checkbox) {
                return;
              }


              const quantityInput =
                addon.querySelector(
                  '[data-addon-quantity-input]'
                );


              const addonVariantId =
                Number(
                  checkbox.dataset
                    .addonVariantId
                );


              if (
                !Number.isFinite(
                  addonVariantId
                ) ||
                addonVariantId <= 0
              ) {
                return;
              }


              let addonQuantity = 1;


              /*
                Fixed add-ons remain quantity 1.

                Quantity add-ons use their own quantity
                selector.
              */

              if (
                addon.dataset.addonType ===
                  'quantity' &&
                quantityInput
              ) {

                addonQuantity =
                  parseInt(
                    quantityInput.value,
                    10
                  ) || 1;

                addonQuantity =
                  Math.max(
                    1,
                    addonQuantity
                  );


                if (
                  quantityInput.max
                ) {
                  const maxQuantity =
                    parseInt(
                      quantityInput.max,
                      10
                    );

                  if (
                    Number.isFinite(
                      maxQuantity
                    )
                  ) {
                    addonQuantity =
                      Math.min(
                        addonQuantity,
                        maxQuantity
                      );
                  }
                }
              }


              items.push({
                id:
                  addonVariantId,

                quantity:
                  addonQuantity,

                properties: {
                  _147_addon_group:
                    addonGroupId,

                  _147_addon_for:
                    String(
                      variantId
                    ),
                },
              });
            }
          );


          /* ==================================================
             NEW 147 CHOICE ADD-ONS
             ================================================== */

          selectedChoiceAddons.forEach(
            (radio) => {

              const addonVariantId =
                Number(
                  radio.dataset.variantId ||
                  radio.value
                );


              if (
                !Number.isFinite(
                  addonVariantId
                ) ||
                addonVariantId <= 0
              ) {
                return;
              }


              /*
                Choice add-ons currently use quantity 1.

                Example:
                2 x cue + selected case
                =
                2 x cue
                1 x case

                This can be changed later if desired.
              */

              items.push({
                id:
                  addonVariantId,

                quantity:
                  1,

                properties: {
                  _147_addon_group:
                    addonGroupId,

                  _147_addon_for:
                    String(
                      variantId
                    ),

                  _147_addon_type:
                    'choice',
                },
              });
            }
          );


          /* --------------------------------------------------
             Build Shopify multi-item payload
             -------------------------------------------------- */

          const payload = {
            items: items,
          };


          /* --------------------------------------------------
             Preserve Dawn cart drawer / notification sections
             -------------------------------------------------- */

          if (this.cart) {

            payload.sections =
              this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                );

            payload.sections_url =
              window.location.pathname;

            this.cart.setActiveElement(
              document.activeElement
            );
          }


          config.body =
            JSON.stringify(
              payload
            );

        } else {

          /* ==================================================
             NO ADD-ONS SELECTED

             Use normal Dawn product submission.
             ================================================== */

          delete config.headers[
            'Content-Type'
          ];


          if (this.cart) {

            formData.append(
              'sections',

              this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                )
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(
              document.activeElement
            );
          }


          config.body =
            formData;
        }


        /* ====================================================
           DAWN CART EVENT
           ==================================================== */

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(
            variantId,
            quantity
          );


        /* ====================================================
           SEND REQUEST
           ==================================================== */

        fetch(
          `${routes.cart_add_url}`,
          config
        )

          .then(
            (response) =>
              response.json()
          )

          .then((response) => {

            /* ================================================
               MULTI-ITEM RESPONSE COMPATIBILITY
               ================================================

               Shopify's multi-item response returns:

               response.items

               Dawn normally expects:

               response.key

               Find the main product in response.items and
               provide Dawn with its line key.
               ================================================ */

            if (
              hasAnySelectedAddons &&
              !response.key &&
              Array.isArray(
                response.items
              ) &&
              response.items.length > 0
            ) {

              const mainAddedItem =
                response.items.find(
                  (item) =>
                    String(
                      item.variant_id
                    ) ===
                    String(
                      variantId
                    )
                ) ||
                response.items[0];


              if (
                mainAddedItem?.key
              ) {
                response.key =
                  mainAddedItem.key;
              }
            }


            /* ================================================
               SHOPIFY ERROR
               ================================================ */

            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source:
                    'product-form',

                  productVariantId:
                    variantId,

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );


              this.handleErrorMessage(
                response.description
              );


              this.dispatchCartErrorEvent(
                response.description ||
                  response.message,
                'INVALID'
              );


              linesUpdateDeferred?.reject(
                new Error(
                  response.description ||
                    response.message
                )
              );


              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );


              if (!soldOutMessage) {
                return;
              }


              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText
                ?.classList.add(
                  'hidden'
                );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }


            /* ================================================
               NO CART DRAWER / NOTIFICATION
               ================================================ */

            if (!this.cart) {

              this.resolveCartLinesUpdate(
                linesUpdateDeferred
              );

              window.location =
                window.routes.cart_url;

              return;
            }


            /* ================================================
               NORMAL DAWN CART UPDATE
               ================================================ */

            this.resolveCartLinesUpdate(
              linesUpdateDeferred
            );


            const startMarker =
              CartPerformance
                .createStartingMarker(
                  'add:wait-for-subscribers'
                );


            if (!this.error) {

              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source:
                    'product-form',

                  productVariantId:
                    variantId,

                  cartData:
                    response,
                }
              ).then(() => {

                CartPerformance
                  .measureFromMarker(
                    'add:wait-for-subscribers',
                    startMarker
                  );

              });
            }


            this.error = false;


            /* ================================================
               QUICK ADD MODAL
               ================================================ */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );


            if (quickAddModal) {

              document.body.addEventListener(
                'modalClosed',
                () => {

                  setTimeout(() => {

                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {

                        this.cart
                          .renderContents(
                            response
                          );

                      }
                    );

                  });

                },
                {
                  once: true,
                }
              );


              quickAddModal.hide(
                true
              );

            } else {

              /* ==============================================
                 NORMAL CART DRAWER / NOTIFICATION
                 ============================================== */

              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {

                  this.cart
                    .renderContents(
                      response
                    );

                }
              );
            }

          })


          /* ==================================================
             NETWORK / JAVASCRIPT ERROR
             ================================================== */

          .catch((e) => {

            console.error(e);


            this.dispatchCartErrorEvent(
              e.message ||
                'Network error',

              'SERVICE_UNAVAILABLE'
            );


            linesUpdateDeferred?.reject(
              e
            );

          })


          /* ==================================================
             RESET BUTTON
             ================================================== */

          .finally(() => {

            this.submitButton
              .classList.remove(
                'loading'
              );


            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }


            if (!this.error) {

              this.submitButton
                .removeAttribute(
                  'aria-disabled'
                );
            }


            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }


            CartPerformance
              .measureFromEvent(
                'add:user-action',
                evt
              );

          });
      }


      /* ======================================================
         ERROR MESSAGE
         ====================================================== */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (
          !this.errorMessageWrapper
        ) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper
            .querySelector(
              '.product-form__error-message'
            );


        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );


        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }


      /* ======================================================
         SUBMIT BUTTON
         ====================================================== */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (!this.submitButton) {
          return;
        }


        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText
              .textContent =
                text;
          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          if (
            this.submitButtonText
          ) {
            this.submitButtonText
              .textContent =
                window.variantStrings
                  .addToCart;
          }
        }
      }


      /* ======================================================
         DAWN STANDARD CART EVENTS
         ====================================================== */

      createCartLinesUpdateEvent(
        variantId,
        quantity
      ) {

        const {
          CartLinesUpdateEvent,
        } =
          window.StandardEvents ||
          {};


        if (!CartLinesUpdateEvent) {
          return null;
        }


        const deferred =
          CartLinesUpdateEvent
            .createPromise();


        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action:
              'add',

            context:
              'product',

            lines: [
              {
                merchandiseId:
                  variantId,

                quantity:
                  quantity,
              },
            ],

            promise:
              deferred.promise,
          })
        );


        return deferred;
      }


      resolveCartLinesUpdate(
        deferred
      ) {

        if (!deferred) {
          return;
        }


        const {
          CartLinesUpdateEvent,
        } =
          window.StandardEvents ||
          {};


        if (!CartLinesUpdateEvent) {
          return;
        }


        const pendingCartDataPromise =
          typeof CartItems !==
            'undefined'
            ? CartItems
                .fetchCartData()
            : fetch(
                `${routes.cart_url}.json`
              ).then(
                (response) =>
                  response.json()
              );


        pendingCartDataPromise

          .then((cart) => {

            if (!cart?.currency) {

              return deferred.reject(
                new Error(
                  'Missing currency in cart response'
                )
              );
            }


            deferred.resolve({
              cart:
                CartLinesUpdateEvent
                  .createCartFromAjaxResponse(
                    cart
                  ),
            });

          })

          .catch(
            (e) =>
              deferred.reject(
                e
              )
          );
      }


      /* ======================================================
         DAWN STANDARD ERROR EVENT
         ====================================================== */

      dispatchCartErrorEvent(
        message,
        code
      ) {

        const {
          CartErrorEvent,
        } =
          window.StandardEvents ||
          {};


        if (!CartErrorEvent) {
          return;
        }


        this.dispatchEvent(
          new CartErrorEvent({
            error:
              message,

            code:
              code,
          })
        );
      }


      /* ======================================================
         SELECTED MAIN VARIANT INPUT
         ====================================================== */

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}